import {useSelector} from 'react-redux';

import {getLocalizedStrings} from '../services/localization/localizationService';
import {selectDeviceNameKey} from '../state/selectors/consumer';

const useDeviceName = () => {
    const localizedStrings = getLocalizedStrings();
    const deviceNameKey = useSelector(selectDeviceNameKey);

    return deviceNameKey ? localizedStrings[deviceNameKey] : '';
};

export default useDeviceName;
